export enum ReportType {
  PomsPerProject = "PomsPerProject",
  PomsPerDay = "PomsPerDay",
}
